import React, { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { getInt } from 'utils/functions';
import GenericFilterTemplateGeneralDataComponent from './GenericFilterTemplateGeneralDataComponent';
import GenericFilterTemplateDetailsComponent from './GenericFilterTemplateDetailsComponent';

const GenericFilterTemplateContainer = () => {
  const match = useRouteMatch();
  const id = useMemo(() => match.params.id && getInt(match.params.id), [match]);

  return (
    <>
      <GenericFilterTemplateGeneralDataComponent id={id} />
      {Boolean(id) && <GenericFilterTemplateDetailsComponent id={id} />}
    </>
  );
};

export default GenericFilterTemplateContainer;
